// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";

// Initialise the mobile menu toggle. This is the only frontend script:
// it is a progressive enhancement and self-guards if its elements are
// absent. Archive navigation does NOT depend on any JavaScript - the
// {{pagination}} links are plain server-rendered HTML.
menuOpen();
